<ng-container>
  @if (root() && item().visible !== false) {
    <div class="text-surface-700 font-bold m-2 dark:text-surface-100">
      {{ item().label }}
    </div>
  }

  @if (item().routerLink && !item().items && item().visible !== false) {
    <a
      (click)="itemClick($event)"
      class="dark:text-surface-0"
      [ngClass]="item().class"
      [routerLink]="item().disabled ? null : item().routerLink"
      routerLinkActive="active-route"
      [routerLinkActiveOptions]="
        item().routerLinkActiveOptions || {
          paths: 'exact',
          queryParams: 'ignored',
          matrixParams: 'ignored',
          fragment: 'ignored',
        }
      "
      [fragment]="item().fragment"
      [queryParamsHandling]="item().queryParamsHandling"
      [preserveFragment]="item().preserveFragment"
      [skipLocationChange]="item().skipLocationChange"
      [replaceUrl]="item().replaceUrl"
      [state]="item().state"
      [queryParams]="item().queryParams"
      [attr.target]="item().target"
      tabindex="0"
      pRipple>
      <div>
        <i [ngClass]="item().icon" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text label-small text-inherit">{{ item().label }}</span>
        @if (item().items) {
          <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
        }
      </div>
    </a>
    @if (item().createLink) {
      <button
        type="button"
        class="quick-create-btn"
        [attr.aria-label]="'Crear ' + item().label"
        (click)="createClick($event)">
        <i class="pi pi-plus"></i>
      </button>
    }
  }

  @if ((!item().routerLink || item().items) && item().visible !== false) {
    <a
      [attr.href]="item().url"
      (click)="itemClick($event)"
      (keydown.enter)="itemClick($event)"
      class="dark:text-surface-0"
      [attr.target]="item().target"
      tabindex="0"
      pRipple>
      <div>
        <i [ngClass]="item().icon" class="layout-menuitem-icon"></i>
        <span class="layout-menuitem-text label-small text-inherit">{{ item().label }}</span>
        @if (item().items) {
          <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
        }
      </div>
    </a>
  }

  @if (item().items && item().visible !== false) {
    <ul #submenu class="m-0 p-0 list-none flex flex-col gap-2 z-50" [@children]="submenuAnimation">
      @for (child of item().items; track $index) {
        <li app-menuitem [item]="child" [index]="$index" [parentKey]="key" [class]="child['badgeClass']"></li>
      }
    </ul>
  }
</ng-container>
